module.exports = __webpack_public_path__ + "static/media/comingsoon.528f13ff.png";